import { render } from "./UIPage.vue?vue&type=template&id=94504de6&scoped=true&ts=true"
import script from "./UIPage.vue?vue&type=script&lang=ts"
export * from "./UIPage.vue?vue&type=script&lang=ts"

import "./UIPage.vue?vue&type=style&index=0&id=94504de6&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94504de6"]])

export default __exports__